import React from "react";

const Popup = ({ color, fill }) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="12" fill={fill} />
        <path
          d="M16 8L8 16M16 16L8 8"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export default Popup;
